{
    "CommonAdminAllTelServer": "[Tutti i server di telefonia]",
    "CommonAdminAnyPartition": "[Qualsiasi partizione]",
    "CommonAdminAnyDevices": "[Qualsiasi dispositivo]",
    "CommonAdminAnyAgents": "[Qualsiasi agente ACD]",
    "CommonAdminAnyAgentForDevice": "[Qualsiasi dispositivo impostato]",
    "CommonAdminAnyDeviceForAgent": "[Qualsiasi con agente ACD impostato]",
    "CommonAdminUnknownOrDeleted": "[Sconosciuto o cancellato]",
    "NAME": "CommonAdmin"
}